import { findKey } from "lodash";
import React from "react";
import ClassificationIcon from "../../../../../../components/ClassificationIcon";
import { getCuckooAndCapeClassification } from "../utils";

const CAPE_LIMITS = {
  UNKNOWN: 2,
  SUSPICIOUS: 7
};

const getCapeResultIcon = score => {
  const classification = getCuckooAndCapeClassification(
    CAPE_LIMITS.UNKNOWN,
    CAPE_LIMITS.SUSPICIOUS,
    score
  );
  return (
    <>
      <ClassificationIcon classification={classification} /> {score} / 10.0
    </>
  );
};

const prepareCapeResult = data => {
  if (!data.length) return null;

  const capeResultKey = findKey(data, o => o.key === "mal_score");
  const capeErrorKey = findKey(data, o => o.key === "error_info");

  if (capeResultKey) {
    return getCapeResultIcon(data[capeResultKey]?.value?.toFixed(1));
  }
  if (capeErrorKey) return "Analysis failed";
  return null;
};

export { prepareCapeResult };
